import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  email: null,
  emails: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const emailReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.EMAIL_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.EMAIL_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.EMAIL_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    default: {
      return state;
    }
  }
};

export default emailReducer;
